import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";

import { Grid, Switch, Button, Paper } from "@material-ui/core";

import FormControlLabel from "@material-ui/core/FormControlLabel";

import ModalContainer from "../../modal/ModalContainer";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import InputLabel from "@material-ui/core/InputLabel";
import "./AcceptRequestModal.css";
@inject("agentVenueStore", "profileStore", "templateStore")
@observer
class AcceptRequestModal extends Component {
    componentWillReceiveProps(nextProps) {
        if (nextProps.open) {
            var rulesJson = JSON.parse(nextProps.request.rules);
            this.props.agentVenueStore.setDayToBook(rulesJson);
        }
    }

    renderDaySwitch = () => {
        return (
            <Grid container spacing={8}>
                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(data => (
                    <Grid item xs={3}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.props.agentVenueStore.dayToBook[data.toLowerCase()]}
                                    onChange={() => this.props.agentVenueStore.toggleDayToBook(data.toLowerCase())}
                                    value={data.toLowerCase()}
                                    color="primary"
                                />
                            }
                            label={data}
                        />
                    </Grid>
                ))}
            </Grid>
        );
    };

    isCurrentStaffProfile = profileId => {
        if (profileId == null) return false;
        const currentProfileId = this.props.profileStore.getCurrentProfile()?.id;
        return String(profileId) === String(this.props.profileId ?? profileId) &&
            String(profileId) === String(currentProfileId);
    };

    handleStaffAccept = async actingProfileId => {
        try {
            await this.props.agentVenueStore.staffAcceptAgentRequest(this.props.request);
            if (!this.isCurrentStaffProfile(actingProfileId)) return;
            this.props.templateStore.openSnackbar("Request has been accepted.");
            this.onClose();
        } catch (error) {
            if (!this.isCurrentStaffProfile(actingProfileId)) return;
            if (error?.requestAccepted) {
                this.onClose();
                if (this.props.onRefreshError) {
                    this.props.onRefreshError(error);
                }
            } else {
                this.props.templateStore.openSnackbar(
                    error?.message || "Unable to accept the agent request."
                );
            }
        } finally {
            this.props.templateStore.hideLoadingScreen();
        }
    };

    handleAccept = () => {
        if (this.props.isStaff) {
            const actingProfileId = this.props.profileId ??
                this.props.profileStore.getCurrentProfile()?.id;
            if (!this.isCurrentStaffProfile(actingProfileId)) return;
            this.props.templateStore.showLoadingScreen();
            return this.handleStaffAccept(actingProfileId);
        }

        this.props.templateStore.showLoadingScreen();
        this.props.agentVenueStore.venueAcceptAgentRequest(this.props.request).then(() => {
            this.props.templateStore.openSnackbar("Request has been accepted.");
            this.props.templateStore.hideLoadingScreen();
            this.onClose();
        });
    };

    handleDecline = () => {
        if (this.props.isStaff) {
            const actingProfileId = this.props.profileId ??
                this.props.profileStore.getCurrentProfile()?.id;
            if (!this.isCurrentStaffProfile(actingProfileId)) return;
            return this.props.agentVenueStore.declineAgentRequest(this.props.request.id).then(() => {
                if (!this.isCurrentStaffProfile(actingProfileId)) return;
                this.props.templateStore.openSnackbar("Request has been declined.");
                this.onClose();
            });
        }

        this.props.agentVenueStore.declineAgentRequest(this.props.request.id).then(() => {
            this.props.templateStore.openSnackbar("Request has been declined.");
            this.onClose();
        });
    };

    onClose = () => {
        this.props.onClose();
    };

    render() {
        return (
            <ModalContainer open={this.props.open} onClose={this.onClose} title="Agent Request" maxWidth="sm">
                <DialogContent
                    style={{
                        paddingTop: "8px"
                    }}
                >
                    {this.props.request ? (
                        <Fragment>
                            <InputLabel>Message</InputLabel>
                            <Paper
                                style={{
                                    minHeight: "320px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: this.props.request.requestMessage }} />
                            </Paper>
                        </Fragment>
                    ) : (
                        ""
                    )}

                    <InputLabel>Day to Book</InputLabel>
                    {this.renderDaySwitch()}
                </DialogContent>
                <DialogActions
                    classes={{
                        root: "dialog-action"
                    }}
                >
                    <Button onClick={this.onClose}>Close</Button>
                    <Button id="btn-accept-agent-request" color="primary" onClick={this.handleAccept} classes={{ root: "pull-right" }}>
                        Accept Request
                    </Button>
                    <Button color="primary" onClick={this.handleDecline} classes={{ root: "pull-right" }}>
                        Decline Request
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default AcceptRequestModal;
